export { VidaLogo } from './VidaLogo';
